import SizeChartModal from './SizeChartModal'

export default SizeChartModal
